/**
 * Shared friend-request Accept/Decline for Activity + notification pane.
 */

import {
  acceptFriendRequest,
  declineFriendRequest,
} from "../../../services/playerRelationshipService";
import { dismissNotificationsForRelationship } from "../../../services/notificationService";

/**
 * @param {'accept'|'decline'} action
 * @param {string} relationshipId
 * @returns {Promise<{ ok: boolean, reason?: string, message?: string }>}
 */
export async function resolveFriendRequestFromNotification(action, relationshipId) {
  if (!relationshipId) {
    return { ok: false, reason: "not_found", message: "Request not found" };
  }
  const result =
    action === "accept"
      ? await acceptFriendRequest(relationshipId)
      : await declineFriendRequest(relationshipId);

  if (result?.ok) {
    dismissNotificationsForRelationship(relationshipId);
    return result;
  }

  // Already resolved elsewhere — clear stale notification rows.
  if (
    result?.reason === "accepted" ||
    result?.reason === "declined" ||
    result?.reason === "cancelled"
  ) {
    dismissNotificationsForRelationship(relationshipId);
  }

  return {
    ok: false,
    reason: result?.reason || "error",
    message:
      result?.message ||
      (result?.reason === "forbidden"
        ? "You can’t respond to this request"
        : result?.reason === "auth_required"
          ? "Sign in to respond"
          : result?.reason === "not_found"
            ? "Request not found"
            : "Could not update friend request"),
  };
}
